import React from 'react';
import { render } from 'react-dom';
import App from "./app/App";
import { BrowserRouter } from "react-router-dom";
render(/*#__PURE__*/React.createElement(React.StrictMode, null, /*#__PURE__*/React.createElement(BrowserRouter, null, /*#__PURE__*/React.createElement(App, null))), document.getElementById('root'));